module.exports = __webpack_public_path__ + "img/icon-3.6443cfcf.png";